import { render, staticRenderFns } from "./contactSelector.vue?vue&type=template&id=8c25b7d6&scoped=true&"
import script from "./contactSelector.vue?vue&type=script&lang=js&"
export * from "./contactSelector.vue?vue&type=script&lang=js&"
import style0 from "./contactSelector.vue?vue&type=style&index=0&id=8c25b7d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c25b7d6",
  null
  
)

export default component.exports